export * from './FileTypeArchiveIcon';
export * from './FileTypeArchiveIcon16Light';
export * from './FileTypeArchiveIcon16Regular';
export * from './FileTypeArchiveIcon16Solid';
export * from './FileTypeArchiveIcon20Light';
export * from './FileTypeArchiveIcon20Regular';
export * from './FileTypeArchiveIcon20Solid';
export * from './FileTypeArchiveIcon24Regular';
export * from './FileTypeArchiveIcon24Solid';
export * from './FileTypeArchiveIcon32Regular';
export * from './FileTypeArchiveIcon64Regular';
